<template>
  <div class="hello">
    <nav class="navbar">
      <div class="nav-l">
        <span class="shij">
          <el-button
            icon="el-icon-plus"
            @click="(onSubmit = true), tianjia()"
            type="primary"
          >
            添加敏感词</el-button
          >
        </span>
      </div>
      <div class="nar-r">
        <span class="shij">
          <el-input
            clearable
            style="width: 26.0rem; margin-right: 2rem"
            placeholder="搜索关键词"
            prefix-icon="el-icon-search"
            v-model="input2"
            @change="rune()"
          >
          </el-input>
          <el-button @click="rune()" type="primary" slot="append">查询</el-button>
        </span>
      </div>
    </nav>
    <el-table
      :data="tableData"
      v-loading="tableLoading"
      border
      style="width: 100%; margin-top: 3.0rem"


    >
    <!-- v-infinite-scroll="load" -->
      <el-table-column prop="keyword" label="关键词" style="width: 10%">
      </el-table-column>
      <el-table-column prop="phone" label="添加人" style="width: 20%">
      </el-table-column>
      <el-table-column prop="createtime" label="时间" style="width: 50%">
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="250">
        <template slot-scope="scope">
          <div v-if="scope.row.phone != '系统管理员'">
            <el-button
              @click="
                (onSubmitn = true), bianji(scope.row.id, scope.row.keyword)
              "
              size="small"
              type="text"
              style="color: #49B372 !important"
            >
              <img src="../../assets/编辑.png" alt=""> 编辑</el-button
            >
            <el-button
              @click="handleClick(scope.row.id)"
              size="small"
              type="text"
              style="color:#f00000 !important"
              ><img src="../../assets/移除.png" alt=""> 移除</el-button
            >
          </div>
          <div v-else-if="scope.row.phone == '系统管理员'" >
            <el-button type="text" size="small" style="color:#C0C4CC !important" disabled><img  src="../../assets/编辑@2x.png" width="12" alt=""> 编辑</el-button>
            <el-button type="text" size="small"  style="color:#C0C4CC !important" disabled><img  src="../../assets/移除@2x.png" width="12" alt=""> 移除</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="keyword"
        label="开启/关闭"
      >
        <template slot-scope="scope">
          <!-- <div v-if="scope.row.is_deny==1"> -->
          <div v-if="scope.row.phone == '系统管理员'">
            <div v-if="tooken.role_id == 0">
              <el-switch
                v-model="scope.row.is_deny"
                :active-value="1"
                :inactive-value="2"
                @change="toggleStatus(scope.row.is_deny, scope.row.id)"
              >
              </el-switch>
            </div>
            <div v-else-if="tooken.role_id != 0">
              <el-switch
                v-model="scope.row.is_deny"
                :active-value="1"
                :inactive-value="2"
                disabled
                @change="toggleStatus(scope.row.is_deny, scope.row.id)"
              >
              </el-switch>
            </div>
          </div>
          <div v-else>
            <el-switch
              v-model="scope.row.is_deny"
              :active-value="1"
              :inactive-value="2"
              @change="toggleStatus(scope.row.is_deny, scope.row.id)"
            >
            </el-switch>
          </div>
          <!-- </div>
          <div v-else-if="scope.row.is_deny==2">
          <el-switch
            v-model="value1"
            @click.native="toggleStatuss()">
          </el-switch>
          </div> -->
        </template>
      </el-table-column>
    </el-table>
    <div class="paging">
        <pagination
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          :page-sizes="[10,20,50,100]"
          :auto-scroll="false"
          @pagination="userTable"
        />
      </div>
    <el-dialog title="添加敏感词" center :visible.sync="onSubmit" width="30%">
      <!-- <div class="bule"></div> -->

      <el-form ref="form" :model="form" label-width="8.0rem">
        <el-form-item label="关键词" prop="name">
          <el-input clearable v-model="form.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmit = false">取 消</el-button>
        <el-button type="primary" @click="numoo()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑" center :visible.sync="onSubmitn" width="30%">
      <!-- <div class="bule"></div> -->

      <el-form ref="form" :model="form" label-width="8.0rem">
        <el-form-item label="关键词" prop="none">
          <el-input clearable v-model="bianjile">{{ bianjile }}</el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmitn = false">取 消</el-button>
        <el-button type="primary" @click="numoon()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  name: "monitoring",
  data() {
    return {
      tableData: [],
      input2: "",
      onSubmit: false,
      onSubmitn: false,
      tableData_a: [],
      multipleSelection: [],
      value1: true,
      form: {
        name: "",
        none: "",
      },
      ele: "",
      yeshu: 1,
      bianjile: "",
      finished: false,
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      tableLoading: true
    };
  },
  mounted() {
    // if (window.sessionStorage.getItem("title")) {
    // let title = JSON.parse(window.sessionStorage.getItem("title"));
    // // // // console.log(userinfo);
    // this.title = title;
    // // // console.log(this.title);
    // var a = document.title;
    // document.title = title[0].website + "-" + a;
    // // // console.log(this.username);
    // }
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据 http://192.168.0.149/api/Prive/getPriveList
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      // // console.log(userinfo);
      this.tooken = userinfo;
    }
    this.userTable();
  },
  methods: {
    //  页数
    // load() {
    //     if(this.finished){
    //       return
    //     }
    //     this.yeshu += 1;
    //     this.axios
    //       .post(
    //         "/home/keyword/getKeywordList",
    //         qs.stringify({
    //           usertoken: this.tooken.usertoken,
    //           account_id: this.tooken.account_id,
    //           phone: this.tooken.phone,
    //           page: this.yeshu,
    //         }),
    //         { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
    //       )
    //       .then((res) => {
    //         if (res.data.msg == "登录超时") {
    //           this.$router.push("/register");
    //         }
    //         if(!res.data.data){
    //           this.finished = true
    //         }
    //         res.data.data.forEach((item) => {
    //           this.tableData.push(item);
    //         });
    //       })
    //       .catch(function (err) {});
    // },
    toggleStatus(e, d) {
      this.yeshu = 1;
      if (e == 1) {
        this.axios
          .post(
            "/home/keyword/editKeyword",
            qs.stringify({
              usertoken: this.tooken.usertoken,
              account_id: this.tooken.account_id,
              // phone:this.tooken.phone,
              account_id: this.tooken.id,
              id: d,
              is_deny: 1,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }
          })
          .catch(function (err) {});
      } else if (e == 2) {
        this.axios
          .post(
            "/home/keyword/editKeyword",
            qs.stringify({
              usertoken: this.tooken.usertoken,
              account_id: this.tooken.account_id,
              // phone:this.tooken.phone,
              account_id: this.tooken.id,
              id: d,
              is_deny: 2,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }
          })
          .catch(function (err) {});
      }
    },
    userTable() {
      this.yeshu = 1;
      this.axios
        .post(
          "/home/keyword/getKeywordList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            page: this.listQuery.page,
            number_page:this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableLoading = false;
          this.tableData = res.data.data;
          this.total = res.data.count
        })
        .catch(function (err) {});
    },
    rune() {
      this.yeshu = 1;
      this.axios
        .post(
          "/home/keyword/getKeywordList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            keyword: this.input2,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    tianjia() {
      this.form.name = "";
      this.yeshu = 1;
      this.axios
        .post(
          "/home/sessionUser/ifRemoveUserTwo",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
          // console.log(this.tableData);
        })
        .catch(function (err) {});
    },
    handleSelectionChange(val) {
      this.yeshu = 1;
      this.multipleSelection = val;
    },
    bianji(e, o) {
      this.yeshu = 1;
      this.ele = e;
      // console.log(o);
      this.bianjile = o;
      // console.log(e);
    },
    // 修改
    numoon() {
      this.yeshu = 1;
      this.axios
        .post(
          "/home/keyword/editKeyword",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            keyword: this.bianjile,
            id: this.ele,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          if (res.data.code == 1) {
            this.onSubmitn = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmitn = true;
            this.$message.error(res.data.msg);
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) {});
    },
    // 添加
    numoo() {
      this.yeshu = 1;
      // // console.log(this.multipleSelection)
      this.axios
        .post(
          "/home/keyword/addKeyword",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,

            phone: this.tooken.phone,
            keyword: this.form.name,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          if (res.data.code == 1) {
            this.onSubmit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmit = true;
            this.$message.error(res.data.msg);
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) {});
    },
    // 移除
    handleClick(e, o) {
      // console.log(o);

      this.yeshu = 1;
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/home/keyword/delKeyword",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                phone: this.tooken.phone,
                id: e,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              // console.log(res);
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
              this.userTable();
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.tableData_a = res.data.data;
            })
            .catch(function (err) {});
        })
        .catch(() => {});
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
  },
};
</script>
<style scoped>
.hello {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}
nav {
  width: 100%;
}
.navbar {
  display: flex;
  justify-content: space-between;
}
.shij {
  display: inline-block;
}
.cell .el-button--primary{
  color: #49B372 !important;
  background: #fff !important;
  border: .1rem solid #49B372 !important;
}
</style>
